import { combineReducers } from 'redux';

import items from './ducks/items';
import query from './ducks/query';

export default combineReducers({
  items: items.reducer,
  query: query.reducer,
});
